import { render, staticRenderFns } from "./AddAnotherPackage.vue?vue&type=template&id=1cb3b668&scoped=true"
import script from "./AddAnotherPackage.vue?vue&type=script&lang=js"
export * from "./AddAnotherPackage.vue?vue&type=script&lang=js"
import style0 from "./AddAnotherPackage.vue?vue&type=style&index=0&id=1cb3b668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb3b668",
  null
  
)

export default component.exports